<template>
  <section class="page-dashbord-users mt-5">
    <app-loading :isFull="true" v-if="isLoading"/>
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'70%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'80%',992:'90%',768:'90%'}"
    >
      <div class="wrapper-form p-4 mb-5" v-if="isModal">
        <div class="row">
          <div class="col-4">
            <div class="group-form">
              <label class="statr" v-if="member.item.level == ''">تغییر دسترسی</label>
              <select v-validate="'required'" name="level" v-model="member.item.level">
                <option value selected disabled v-if="member.item.level != ''">تغییر دسترسی</option>
                <option
                  v-for="(option,index) in memberOptions"
                  :value="option.id"
                  :key="index"
                >{{option.text}}</option>
              </select>
              <span class="bar"></span>
              <span v-if="errors.has('level')" class="is-danger">فیلد نباید خالی باشد</span>
            </div>
          </div>
          <!-- member.isactive -->
          <div class="col-6">
            <div class="input-checkbox rtl text-right">
              <div class="md-checkbox">
                <input type="checkbox" :id="member.item.id" v-model="member.item.isactive">
                <label
                  :for="member.item.id"
                  class="font-14"
                >{{member.item.isactive ? 'غیر فعال کردن کاربر' : 'فعال کردن کاربر'}}</label>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              @click="hideModal"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-danger"
              v-ripple
            >انصراف</button>
            <button
              @click="updateUser"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
            >ذخیره</button>
          </div>
        </div>
      </div>
    </vue-modaltor>
    <vue-modaltor
      :visible="isPassword"
      @hide="hideModalPassword"
      :default-width="'70%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'80%',992:'90%',768:'90%'}"
    >
      <div class="wrapper-form p-4 mb-5" v-if="isPassword">
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="group-form">
              <input
                v-validate="{ required: true, regex: /^(?=.*\d).{8,}$/ }"
                name="newPassword"
                type="password"
                :class="{active:formPassword.new_password != ''}"
                v-model="formPassword.new_password"
              >
              <span class="bar"></span>
              <label>{{ $t('label.newPassword')}}</label>
              <span
                v-if="errors.has('newPassword')"
                class="is-danger"
              >{{$t('message.require.error.password')}}</span>
            </div>
          </div>
          <div class="col-lg-12 col-12">
            <div class="group-form">
              <input
                v-validate="'required|confirmed:newPassword'"
                data-vv-as="newPassword"
                name="re_new_password"
                type="password"
                :class="{active:formPassword.re_new_password != ''}"
                v-model="formPassword.re_new_password"
              >
              <span class="bar"></span>
              <label>{{ $t('label.re_password')}}</label>
              <span
                v-if="errors.has('re_new_password')"
                class="is-danger"
              >{{$t('message.require.error.re_password')}}</span>
            </div>
          </div>
          <div class="text-center">
            <button
              @click="hideModalPassword"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-danger"
              v-ripple
            >انصراف</button>
            <button
              @click="updateUserPassword"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
            >ذخیره</button>
          </div>
        </div>
      </div>
    </vue-modaltor>
    <div class="container">
      <div class="row no-gutters">
        <div class="col-12 px-3">
          <header class="mb-3">
            <h2 class="font-18 text-right">لیست کاربران</h2>
          </header>
          <div class="shadow shadow-sm mb-5 bg-white" v-if="users && users.length">
            <b-table stacked="lg" striped :fields="fieldsItems" :items="users" class="text-center">
              <template
                v-slot:cell(isactive)="data" 
              >{{data.item.isactive ? 'فعال' : 'غیر فعال' }}</template>
              <template v-slot:cell(fullname)="data">{{data.item.fullname}}</template>
              <template v-slot:cell(action)="row" >
                <div class="text-center">
                  <span data-balloon-pos="up" data-balloon="حذف کاربر">
                    <button
                      class="bttn-material-circle bttn-jelly bttn-md bttn-danger text-center"
                      v-ripple
                      @click.stop="remove(row.item, row.index)"
                    >
                      <i class="flaticon-dustbin"></i>
                    </button>
                  </span>
                  <span data-balloon-pos="up" data-balloon="سطح دسترسی">
                    <button
                      class="bttn-material-circle bttn-jelly bttn-md bttn-success text-center"
                      v-ripple
                      @click="openModal(row.item, row.index)"
                    >
                      <i class="flaticon-secure-shield"></i>
                    </button>
                  </span>
                  <span data-balloon-pos="up" data-balloon="تغییر کلمه عبور">
                    <button
                      class="bttn-material-circle bttn-jelly bttn-md bttn-royal text-center"
                      v-ripple
                      @click="openModalPassword(row.item, row.index)"
                    >
                      <i class="flaticon-login"></i>
                    </button>
                  </span>
                  <span data-balloon-pos="up" data-balloon="ارسال ایمیل فعال سازی">
                    <button
                      class="bttn-material-circle bttn-jelly bttn-md bttn-primary text-center"
                      v-ripple
                      @click="resendEmail(row.item, row.index)"
                    >
                      <i class="flaticon-mail"></i>
                    </button>
                  </span>

                  <!--<router-link :to="'/dashbord/user/'+row.item.id" class="bttn-material-circle bttn-md bttn-royal text-center" v-ripple  :title="'ویرایش'">-->
                  <!--<i class="mdi mdi-grease-pencil"></i>-->
                  <!--</router-link>-->
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <page-number :lengthList="lengthList" @callBack="callBack"/>
    </div>
  </section>
</template>

<script>
import contactForm from "cp/contact-form.vue";

export default {
  name: "page-dashbord-users",
  components: {
    contactForm
  },
  data() {
    return {
      lengthList: 15,
      isPassword: false,
      passwordItem: null,
      formPassword: {
        new_password: "",
        re_new_password: ""
      },
      member: {},
      memberOptions: [
        { text: "کاربر عادی", id: 1 },
        { text: "سوپر یوزر", id: 7 }
      ],
      isModal: false,
      isLoading: true,
      fieldsItems: [
        { key: "fullname", label: "نام" },
        { key: "username", label: "نام کاربری" },
        { key: "email", label: "ایمیل" },
        {
          key: "isactive",
          label: "وضعیت",
          sortable: true,
          tdClass: (value, key, item) => {
            return item.isactive
              ? "font-12 table-success"
              : "font-12  table-danger";
          }
        },
        { key: "action", label: "عملیات" }
      ],
      page: 1
    };
  },
  computed: {
    users() {
      return this.$store.state.dashboardUsers.users;
    }
  },
  mounted() {
    this.callBack(1);
    this.isLoading = false;
  },
  methods: {
    async updateUserPassword() {
      try {
        let body = {
          new_password: this.formPassword.new_password,
          re_new_password: this.formPassword.re_new_password,
          user_id: this.passwordItem.item.id
        };
        let { data } = await axios.post("/users/set-new-pass-by-su", body);
        if (data.state !== 200) return;
        this.hideModalPassword();
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
      } catch (error) {
        console.log(error);
      }
    },
    async resendEmail(item, index) {
      let result = window.confirm("آیا اطمینان دارید؟");
      if (!result) return;
      try {
        let { data } = await axios.post("/users/resend-email", {
          email: item.email
        });
        if (data.state !== 200) return;
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
      } catch (error) {
        console.log(error);
      }
    },
    hideModalPassword() {
      this.passwordItem = null;
      this.isPassword = false;
    },
    openModalPassword(item, index) {
      this.passwordItem = { item, index };
      this.isPassword = true;
    },
    async callBack(p) {
      this.isLoading = true;
      this.page = p;
      let total = await this.$store.dispatch("dashboardUsers/getAllUser", {
        page: this.page
      });
      this.lengthList = total;
      this.isLoading = false;
    },
    openModal(item, index) {
      this.member = { item, index };
      this.isModal = true;
    },
    hideModal() {
      this.member = {};
      this.isModal = false;
    },
    submitAction(row) {
      row.toggleDetails();
    },
    async remove(item, index) {
      try {
        let result = window.confirm("آیا از حذف این کاربر اطمینان دارید؟");
        if (!result) return;
        this.isLoading = true;
        let { data } = await axios.post("/users/delete", { user_id: item.id });
        this.isLoading = false;
        if (data.state !== 200) {
          if (data.state == 403) {
            this.$root.showWarnMsg({
              title: "مجوز",
              message: "این کار بر فعال میباشد"
            });
          }
          return;
        }
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
        this.users.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    edit(item, index) {
      console.log(item, index);
    },
    async updateUser() {
      try {
        let body = {
          isactive: this.member.item.isactive,
          level: this.member.item.level,
          user_id: this.member.item.id
        };
        let { data } = await axios.post("/users/edit", body);
        this.hideModal();
        if (data.state !== 200) {
          if (data.state == 403) {
            this.$store.commit("notifications/error", {
              message: "شما مجوز این عملیات را ندارید",
              title: "مجوز"
            });
          }
          return;
        }
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";

.page-dashbord-users {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/users.vue